import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { Columns3, Gauge, House, IconNode, LayoutGrid, List, Plus, Square, Star, Tags, TextAlignStart, User } from 'lucide';

interface SidebarMenuItem {
    label: string;
    icon?: IconNode;
    routerLink?: string;
    children?: SidebarMenuItem[];
    pinToBottom?: boolean;
    collapsed?: boolean;
}

export const MENU_ITEMS: SidebarMenuItem[] = [
    { label: marker('sidebar.dashboard'), icon: House, routerLink: '/dashboard' },
    {
        label: marker('sidebar.inventory'),
        children: [
            { label: marker('sidebar.cartons'), icon: Square, routerLink: '/cartons' },
            { label: marker('sidebar.pallets'), icon: Columns3, routerLink: '/pallets' },
            { label: marker('sidebar.products'), icon: Star, routerLink: '/products' },
        ],
    },
    {
        label: marker('sidebar.warehouse-assignments'),
        children: [
            { label: marker('sidebar.warehouse-assignments.create'), icon: Plus, routerLink: '/warehouse-assignments/create' },
            { label: marker('sidebar.warehouse-assignments.list'), icon: List, routerLink: '/warehouse-assignments/list' },
            { label: marker('sidebar.warehouse-assignments.products'), icon: Tags, routerLink: '/warehouse-assignments/products' },
        ],
    },
    {
        label: marker('sidebar.reports'),
        children: [
            { label: marker('sidebar.reports.users'), icon: TextAlignStart, routerLink: '/reports/users' },
            { label: marker('sidebar.reports.stations'), icon: Gauge, routerLink: '/reports/stations' },
        ],
    },
    {
        label: marker('sidebar.infrastructure'),
        children: [
            { label: marker('sidebar.stations'), icon: LayoutGrid, routerLink: '/stations' },
            { label: marker('sidebar.racks'), icon: Columns3, routerLink: '/racks' },
            { label: marker('sidebar.printers'), icon: Square, routerLink: '/printers' },
            { label: marker('sidebar.system-configurations'), icon: Columns3, routerLink: '/system-configurations' },
        ],
    },
    {
        label: marker('sidebar.logs'),
        children: [
            { label: marker('sidebar.scan-logs'), icon: List, routerLink: '/scan-logs' },
            { label: marker('sidebar.print-jobs'), icon: List, routerLink: '/print-jobs' },
        ],
    },
    {
        label: marker('sidebar.accounts'),
        children: [
            { label: marker('sidebar.admins'), icon: User, routerLink: '/admins' },
            { label: marker('sidebar.users'), icon: List, routerLink: '/users' },
        ],
    },
    {
        label: marker('sidebar.dev'),
        pinToBottom: true,
        collapsed: true,
        children: [
            { label: marker('sidebar.test-flow'), icon: LayoutGrid, routerLink: '/test-flow' },
            { label: marker('sidebar.metrics'), icon: List, routerLink: '/metrics' },
        ],
    },
];
